import { useState, useEffect, useCallback, useRef } from "react";
import { api } from "../api/client";

export function useData<T>(path: string | null, deps: unknown[] = []) {
  const [data, setData] = useState<T | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  // Monotonic id so a slow response for an old path/refetch can never
  // overwrite the result of a newer one (e.g. fast tab switching).
  const seq = useRef(0);

  const refetch = useCallback(() => {
    const id = ++seq.current;
    if (!path) return;
    setLoading(true);
    setError(null);
    api
      .get<T>(path)
      .then((d) => {
        if (seq.current !== id) return;
        setData(d);
        setLoading(false);
      })
      .catch((e) => {
        if (seq.current !== id) return;
        setError(e.message);
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, ...deps]);

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, loading, error, refetch, setData };
}
